import { Injectable } from '@angular/core';
import { ProjectSubType, ProjectType } from '@frontend-site/shared/data';

const PROJECT_TYPE_KEYS: Record<number, string> = {
    [ProjectType.UPGRADE]: 'ProjectInfo.ProjectType.UPGRADE',
    [ProjectType.CLEANSING]: 'ProjectInfo.ProjectType.CLEANSING',
    [ProjectType.SUPPORT_PACKAGE]: 'ProjectInfo.ProjectType.SUPPORT_PACKAGE',
    [ProjectType.SUPPORT_PACKAGE_NEW]: 'ProjectInfo.ProjectType.SUPPORT_PACKAGE_NEW',
    [ProjectType.TESTING_ONLY]: 'ProjectInfo.ProjectType.TESTING',
    [ProjectType.ENHANCEMENT_PACKAGE]: 'ProjectInfo.ProjectType.ENHANCEMENT_PACKAGE',
    [ProjectType.ORACLE_PATCHES]: 'ProjectInfo.ProjectType.ORACLE_PATCHES',
    [ProjectType.JDE]: 'ProjectInfo.ProjectType.JDE_ANALYSIS',
    [ProjectType.ORACLE_UPGRADE]: 'ProjectInfo.ProjectType.ORACLE_UPGRADE',
    [ProjectType.ORACLE_ONLINE_PATCHES]: 'ProjectInfo.ProjectType.ORACLE_ONLINE_PATCHES',
    [ProjectType.STANDALONE_PROJECT]: 'ProjectInfo.ProjectType.STANDALONE_PROJECT',
    [ProjectType.S4_DISCOVERY_PACK]: 'ProjectInfo.ProjectType.S4_DISCOVERY_PACK',
    [ProjectType.S4_CONVERT]: 'ProjectInfo.ProjectType.S4_CONVERSION',
    [ProjectType.S4_ACCELERATE]: 'ProjectInfo.ProjectType.S4_ACCELERATE',
    [ProjectType.ICR_3]: 'ProjectInfo.ProjectType.ICR_3',
    [ProjectType.S4_GREEN]: 'ProjectInfo.ProjectType.S4_GREEN',
    [ProjectType.S4_CONVERT_NEW]: 'ProjectInfo.ProjectType.S4_CONVERT_NEW',
    [ProjectType.S4_ACCELERATE_NEW]: 'ProjectInfo.ProjectType.S4_ACCELERATE_NEW'
};

const PROJECT_SUBTYPE_KEYS: Record<number, string> = {
    [ProjectSubType.ORACLE_UPGRADE]:       'ProjectInfo.ProjectSubtype.ORACLE_UPGRADE',
    [ProjectSubType.END2END_SUBTYPE]:      'ProjectInfo.ProjectSubtype.END2END_TESTING',
    [ProjectSubType.VF_SECURITY]:          'ProjectInfo.ProjectSubtype.VF_SECURITY',
    [ProjectSubType.IMPACT_ANALYSIS]:      'ProjectInfo.ProjectSubtype.FUNCTIONAL_CHANGES',
    [ProjectSubType.ONGOING_CHANGES]:      'ProjectInfo.ProjectSubtype.ONGOING_CHANGES',
    [ProjectSubType.S4_PREP]:              'ProjectInfo.ProjectSubtype.S4_PREP',
    [ProjectSubType.S4_GREEN_BASIC]:       'ProjectInfo.ProjectSubtype.S4_GREEN_BASIC',
    [ProjectSubType.ICR_3_S4_CONVERSION]:  'ProjectInfo.ProjectSubtype.ICR_3_S4_CONVERSION',
    [ProjectSubType.ICR_3_S4_ACCELERATE]:  'ProjectInfo.ProjectSubtype.ICR_3_S4_ACCELERATE',
};

@Injectable({ providedIn: 'root' })
export class ProjectTypeService {
    getTranslateKey(projectType: number, projectSubtype: number): string {
        const useSubtype =
            (projectType === ProjectType.TESTING_ONLY && !!projectSubtype) ||
            (projectType === ProjectType.ORACLE_UPGRADE && projectSubtype !== ProjectSubType.ORACLE_UPGRADE);
        return useSubtype
            ? (PROJECT_SUBTYPE_KEYS[projectSubtype] ?? '')
            : (PROJECT_TYPE_KEYS[projectType] ?? '');
    }
}
